import {i18n} from "../../../vue-i18n";

export default class RemoveLessor {
  constructor(contractId, removedLessorId, newPaymentsRates) {
    this.commandName = "RemoveLessor";
    this.contractId = contractId;
    this.removedLessorId = removedLessorId;
    this.newPaymentsRates = newPaymentsRates;

    this.description = `${i18n.t('CONTENT.events.RemoveLessor')}`;
    this.description = '';
  }

  // Use this method to push this command to the server
  serialize() {
    const serialisedCommand = JSON.stringify({
      contractId: this.contractId,
      removedLessorId: this.removedLessorId,
      newPaymentsRates: this.newPaymentsRates,
    });

    return {
      commandName: this.commandName,
      serialisedCommand,
    };
  }

  equal() {
    // will always return false so user can add multiple payments
    return false;
  }
}
